import type { ContactFormData } from '@/types';

/**
 * Submit the contact form to the backend API.
 *
 * @param data - The form data to submit.
 * @returns A promise resolving to the API response status.
 */
export async function submitContactForm(data: ContactFormData): Promise<{ success: boolean; error?: string }> {
  try {
    const response = await fetch('/api/contact', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    });

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      
      // If we have validation issues from Zod
      if (response.status === 400 && errorData.error === 'Validation failed' && Array.isArray(errorData.details)) {
        const issues = errorData.details.map((issue: any) => issue.message).join(', ');
        return { success: false, error: `Validation failed: ${issues}` };
      }

      return { success: false, error: errorData.error || 'Failed to submit form' };
    }

    return { success: true };
  } catch (error) {
    console.error('Contact form submission error:', error);
    return { success: false, error: 'Network error. Please try again.' };
  }
}
